// Venta del backoffice en el vocabulario del detalle compartido con Mis ventas. Puro.
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';
import { toPaymentLines } from '@/shared/lib/format/salePaymentLines';
import type { SaleDetailFacts } from '@/domains/sales/portal/mysales/components/SaleDetailSections';

export function ventaDetailFacts(sale: BackofficeSale): SaleDetailFacts {
    return {
        saleId: sale.saleId,
        folio: sale.folio,
        soldAt: sale.soldAt,
        storeName: sale.storeName,
        zoneName: sale.zoneName,
        sellerLabel: sale.sellerName ?? '—',
        type: sale.type,
        externalProvider: sale.externalProvider,
        creditId: sale.creditId,
        paymentMethod: sale.paymentMethod,
        payments: toPaymentLines(sale.payments),
        ...(sale.paymentDetail?.cashConfirmedInRegister !== undefined && {
            cashConfirmed: sale.paymentDetail.cashConfirmedInRegister,
        }),
        amountCents: sale.amountCents,
        downPaymentCents: sale.downPaymentCents,
        equipmentPriceCents: sale.equipmentPriceCents,
        ...(sale.lines !== undefined && { lines: sale.lines }),
        sku: sale.sku,
        imei: sale.imei,
        productBrand: sale.productBrand,
        productModel: sale.productModel,
        productCapacity: sale.productCapacity,
        ...(sale.salePromotionId !== undefined && { salePromotionId: sale.salePromotionId }),
        ...(sale.salePromotionVersion !== undefined && {
            salePromotionVersion: sale.salePromotionVersion,
        }),
    };
}
